import Container from "../Container"
import Gallery from "react-photo-gallery"
import React, { useState, useCallback } from "react"
import Carousel, { Modal, ModalGateway } from "react-images"

const photos = [
  {
    src: "/kuva1.jpg",
    width: 545,
    height: 700,
  },
  {
    src: "/kuva2.jpg",
    width: 494,
    height: 700,
  },
  {
    src: "/kuva4.JPG",
    width: 620,
    height: 700,
  },
  {
    src: "/kuva3.JPG",
    width: 549,
    height: 700,
  },
  {
    src: "/kuva5.JPG",
    width: 510,
    height: 700,
  },
  {
    src: "/kuva6.JPG",
    width: 528,
    height: 700,
  },
  {
    src: "/kuva7.JPG",
    width: 573,
    height: 700,
  },
  {
    src: "/kuva8.jpg",
    width: 536,
    height: 700,
  },
  {
    src: "/kuva9.jpg",
    width: 472,
    height: 700,
  },
  {
    src: "/kuva10.JPG",
    width: 713,
    height: 700,
  },
  {
    src: "/kuva11.JPG",
    width: 535,
    height: 700,
  },
  {
    src: "/kuva12.JPG",
    width: 623,
    height: 700,
  },
  {
    src: "/kuva13.JPG",
    width: 562,
    height: 700,
  },
  {
    src: "/kuva14.JPG",
    width: 538,
    height: 700,
  },
  {
    src: "/kuva15.JPG",
    width: 603,
    height: 700,
  },
  {
    src: "/kuva16.jpg",
    width: 463,
    height: 700,
  },
  {
    src: "/kuva17.jpg",
    width: 750,
    height: 700,
  },
  {
    src: "/kuva18.JPG",
    width: 535,
    height: 700,
  },
]

const shopphotos = [
  {
    src: "/gaialiike1.JPG",
    width: 479,
    height: 700,
  },
  {
    src: "/gaialiike2.JPG",
    width: 519,
    height: 700,
  },
  {
    src: "/gaialiike3.JPG",
    width: 456,
    height: 700,
  },
  {
    src: "/gaialiike4.JPG",
    width: 525,
    height: 700,
  },
  {
    src: "/gaialiike5.JPG",
    width: 525,
    height: 700,
  },
  {
    src: "/gaialiike6.jpg",
    width: 512,
    height: 700,
  },
  {
    src: "/gaialiike7.jpg",
    width: 525,
    height: 700,
  },
]

function GallerySection() {
  const [currentImage, setCurrentImage] = useState(0)
  const [viewerIsOpen, setViewerIsOpen] = useState(false)
  const [currentImageShop, setCurrentImageShop] = useState(0)
  const [viewerIsOpenShop, setViewerIsOpenShop] = useState(false)
  const shopPhotoRows = [shopphotos.slice(0, 3), shopphotos.slice(3)]

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index)
    setViewerIsOpen(true)
  }, [])

  const closeLightbox = () => {
    setCurrentImage(0)
    setViewerIsOpen(false)
  }

  const openLightboxShop = useCallback((event, { photo, index }) => {
    setCurrentImageShop(index)
    setViewerIsOpenShop(true)
  }, [])

  const closeLightboxShop = () => {
    setCurrentImageShop(0)
    setViewerIsOpenShop(false)
  }
  return (
    <Container className="gallery" id="gallery">
      <h1
        style={{
          textAlign: `center`,
        }}
      >
        {" "}
        Galleria{" "}
      </h1>
      <hr />
      <div className="shop-gallery">
        {shopPhotoRows.map((row, rowIndex) => (
          <div
            className={`shop-gallery__row shop-gallery__row--${row.length}`}
            key={`shop-row-${rowIndex}`}
          >
            {row.map((photo, photoIndex) => {
              const index = rowIndex === 0 ? photoIndex : photoIndex + shopPhotoRows[0].length

              return (
                <button
                  type="button"
                  className="shop-gallery__item"
                  key={photo.src}
                  onClick={event => openLightboxShop(event, { photo, index })}
                >
                  <img
                    src={photo.src}
                    alt=""
                    className="shop-gallery__image"
                  />
                </button>
              )
            })}
          </div>
        ))}
        <ModalGateway>
          {viewerIsOpenShop ? (
            <Modal onClose={closeLightboxShop}>
              <Carousel
                currentIndex={currentImageShop}
                views={shopphotos.map(x => ({
                  ...x,
                  srcset: x.srcSet,
                  caption: x.title,
                }))}
              />
            </Modal>
          ) : null}
        </ModalGateway>
      </div>
      <hr></hr>
      <div>
        <Gallery photos={photos} onClick={openLightbox} />
        <ModalGateway>
          {viewerIsOpen ? (
            <Modal onClose={closeLightbox}>
              <Carousel
                currentIndex={currentImage}
                views={photos.map(x => ({
                  ...x,
                  srcset: x.srcSet,
                  caption: x.title,
                }))}
              />
            </Modal>
          ) : null}
        </ModalGateway>
      </div>
      <br />
      <br />
      <br />
    </Container>
  )
}

export default GallerySection
